import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, LogIn, Mail } from "lucide-react";

/**
 * Mobile-only bottom tab bar for public routes. Sticky, safe-area aware,
 * gives the site an app-like feel on phones. Hidden on md+ screens.
 */
export default function MobileTabBar() {
  const location = useLocation();
  // Hide on admin/organizer authenticated flows
  if (
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/organizer") ||
    location.pathname.startsWith("/login")
  ) {
    return null;
  }

  const tabs = [
    { to: "/", label: "Home", icon: Home, exact: true, testid: "tab-home" },
    { to: "/#active-events", label: "Events", icon: Search, testid: "tab-events" },
    { to: "/#contact-section", label: "Contact", icon: Mail, testid: "tab-contact" },
    { to: "/login", label: "Sign in", icon: LogIn, testid: "tab-signin" },
  ];

  return (
    <nav
      className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-white border-t border-[#E2E8F0] pb-safe"
      data-testid="mobile-tab-bar"
      aria-label="Primary"
    >
      <div className="grid grid-cols-4">
        {tabs.map((t) => {
          const Icon = t.icon;
          const active =
            t.exact
              ? location.pathname === "/" && !location.hash
              : t.to.includes("#")
              ? location.pathname === "/" && location.hash === t.to.slice(1)
              : location.pathname.startsWith(t.to);
          return (
            <NavLink
              key={t.to}
              to={t.to}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] transition-colors ${
                active ? "text-[#5B4CFF]" : "text-[#475569] hover:text-[#0F172A]"
              }`}
              data-testid={t.testid}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 2} />
              <span className="text-[10px] font-semibold tracking-wide">{t.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
